import { switchAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system';

const { defineMultiStyleConfig, definePartsStyle } = createMultiStyleConfigHelpers(
  switchAnatomy.keys,
);

const baseStyle = definePartsStyle({
  container: {
    display: 'inline-flex',
    alignItems: 'center',
  },
  track: {
    bg: 'border.muted',
    transitionProperty: 'common',
    transitionDuration: 'normal',
    _hover: {
      bg: 'border.emphasized',
    },
    _focusVisible: {
      boxShadow: '0 0 0 2px var(--chakra-colors-accent-default)',
    },
    _checked: {
      bg: 'accent.default',
      color: 'accent.on',
      _hover: {
        bg: 'accent.default',
      },
    },
    _disabled: {
      opacity: 1,
      bg: 'border.muted',
      cursor: 'not-allowed',
    },
  },
  thumb: {
    bg: 'bg.input',
    borderWidth: '1px',
    borderColor: 'border.emphasized',
    transitionProperty: 'transform, background-color, border-color',
    transitionDuration: 'normal',
    _checked: {
      bg: 'bg.input',
      borderColor: 'border.emphasized',
    },
    _disabled: {
      bg: 'bg.disabled',
      borderColor: 'border.muted',
    },
  },
});

export const Switch = defineMultiStyleConfig({
  baseStyle,
});
